// extracted by mini-css-extract-plugin
module.exports = {"title":"SideBaner_title__mHn_o","image":"SideBaner_image__1ODg7"};